import Vuex from 'vuex'
import Vue from 'vue'
import Axios from 'axios'
import Nes from 'nes/client'
import BigNumber from 'BigNumber.js'
import _ from 'lodash'
import moment from 'moment'

Vue.use(Vuex)

const axios = Axios.create({
  withCredentials: true
})

const store = new Vuex.Store({
  state: {
    count: 0,
    bets: {},
    ticketRaffles: {},
    users: {},
    userIdByTwitchNames: {},
    placedBets: {}, // betId => [<pb>]
    myBets: {},
    myTickets: {},
    ticketRaffleEntries: {},
    ticketRaffleWinners: {},
    orders: {},
    currentTicketRaffleIds: [],
    balanceLeaderboard: [],
    watchTimeLeaderboard: [],
    currentBetIds: [],
    subBounties: [],
    ownedLootItems: {},
    myOwnedLootItemIds: [],
    lootShopLootItemIds: [],
    lootShopLootItems: {},
    lootItems: {},
    noCurrentUser: false,
    currentBalance: undefined,
    currentGoldBalance: undefined,
    roomItemPages: [],
    roomItemPageCurrent: -1,
    lootBoxPages: [],
    lootBoxPageCurrent: -1,
    userRates: null,
    callFree: true
  },
  mutations: {
    increment (state) {
      state.count++
    },
    betsUpdate (state, bets) {
      for (let bet of bets) {
        Vue.set(state.bet, bet.id, bet)
      }
    },
    placedBetsUpdate (state, data) {
      let pbs = data.placed_bets || []
      let mbs = data.my_bets || []
      pbs = pbs.map(pb => {
        pb.amount = new BigNumber(pb.amount)
        return pb
      })

      mbs = mbs.map(pb => {
        pb.amount = new BigNumber(pb.amount)
        return pb
      })

      pbs.sort((pb1, pb2) => {
        if (pb1.amount.gt(pb2.amount)) {
          return -1
        } else if (pb2.amount.gt(pb1.amount)) {
          return 1
        } else {
          return 0
        }
      })

      mbs.sort((pb1, pb2) => {
        if (pb1.amount.gt(pb2.amount)) {
          return -1
        } else if (pb2.amount.gt(pb1.amount)) {
          return 1
        } else {
          return 0
        }
      })

      // state.placedBets[pbs[0].bet_id] = pbs

      Vue.set(state.placedBets, pbs[0].bet_id, pbs)
      Vue.set(state.myBets, mbs[0].bet_id, mbs)
      // for (let pb of pbs) {
      //   if (!state.placedBets[pb.bet_id]) {
      //     state.placedBets[pb.bet_id] = [pb]
      //   } else {
      //     state.placedBets[pb.bet_id].push(pb)
      //   }
      // }
    },
    newTicketRaffle (state, tr) {
      tr.created_at = moment(tr.created_at)
      tr.updated_at = moment(tr.updated_at)
      tr.total_entries = new BigNumber(tr.total_entries)
      Vue.set(state.ticketRaffles, tr.id, tr)

      if (state.currentTicketRaffleIds.indexOf(tr.id) === -1) {
        state.currentTicketRaffleIds.push(tr.id)

        state.currentTicketRaffleIds.sort((trid1, trid2) => {
          if (
            state.ticketRaffles[trid1].status === 1 &&
            state.ticketRaffles[trid2].status !== 1
          ) {
            return -1
          }

          if (
            state.ticketRaffles[trid2].status === 1 &&
            state.ticketRaffles[trid1].status !== 1
          ) {
            return 1
          }

          if (
            state.ticketRaffles[trid1].updated_at >
            state.ticketRaffles[trid2].updated_at
          ) {
            return -1
          } else {
            return 1
          }
        })
      }
    },
    newTicketRaffleEntry (state, tre) {
      let cur = state.ticketRaffleEntries[tre.ticket_raffle_id] || []
      let existing = cur.find(c => c.user_id === tre.user_id)

      tre.quantity = new BigNumber(tre.quantity)

      if (existing) {
        cur = cur.filter(c => c.user_id !== tre.user_id)
      }
      cur.unshift(tre)
      cur.sort((tre1, tre2) => {
        if (tre1.quantity > tre2.quantity) {
          return -1
        } else if (tre2.quantity > tre1.quantity) {
          return 1
        }

        if (tre1.updated_at > tre2.updated_at) {
          return -1
        } else {
          return 1
        }
      })

      let tr = state.ticketRaffles[tre.ticket_raffle_id]
      tr.total_entries = tr.total_entries.plus(
        tre.quantity.minus(new BigNumber(existing ? existing.quantity : 0))
      )

      Vue.set(state.ticketRaffles, tr.id, tr)

      Vue.set(state.ticketRaffleEntries, tre.ticket_raffle_id, cur)
    },
    newTicketRaffleWinner (state, winner) {
      let cur = state.ticketRaffleWinners[winner.ticket_raffle_id] || []
      cur.push(winner)

      Vue.set(state.ticketRaffleWinners, winner.ticket_raffle_id, cur)
    },
    setMyTickets (state, trs) {
      for (let tr of trs) {
        tr.created_at = moment(tr.created_at)
        tr.updated_at = moment(tr.updated_at)
        tr.total_entries = new BigNumber(tr.total_entries)

        Vue.set(state.myTickets, tr.id, tr)
      }
    },
    setLootItems (state, lootItems) {
      for (let li of lootItems) {
        // li.created_at = moment(li.created_at)
        // li.updated_at = moment(li.updated_at)

        Vue.set(state.lootItems, li.id, li)
      }
    },
    setLootShopLootItems (state, lootItems) {
      for (let li of lootItems) {
        // li.created_at = moment(li.created_at)
        // li.updated_at = moment(li.updated_at)
        if (state.lootShopLootItemIds.indexOf(li.id) === -1) {
          state.lootShopLootItemIds.push(li.id)
        }

        Vue.set(state.lootShopLootItems, li.id, li)
      }
    },
    setOwnedLootItems (state, lootItems) {
      for (let li of lootItems) {
        // li.created_at = moment(li.created_at)
        // li.updated_at = moment(li.updated_at)
        if (state.myOwnedLootItemIds.indexOf(li.id) === -1) {
          state.myOwnedLootItemIds.push(li.id)
        }

        if (li.loot_item) {
          Vue.set(state.lootItems, li.loot_item.id, li.loot_item)
        }
        // someObject = Object.assign({}, li)
        Vue.set(state.ownedLootItems, li.id, li)
      }
    },
    setTicketRaffles (state, trs) {
      // console.log('set ticket raffles', trs)

      for (let tr of trs) {
        tr.created_at = moment(tr.created_at)
        tr.updated_at = moment(tr.updated_at)
        tr.total_entries = new BigNumber(tr.total_entries)

        Vue.set(state.ticketRaffles, tr.id, tr)
      }

      let ids = trs.map(tr => tr.id)

      ids.sort((trid1, trid2) => {
        if (
          state.ticketRaffles[trid1].status === 1 &&
          state.ticketRaffles[trid2].status !== 1
        ) {
          return -1
        }

        if (
          state.ticketRaffles[trid2].status === 1 &&
          state.ticketRaffles[trid1].status !== 1
        ) {
          return 1
        }
        // console.log(state.ticketRaffles[trid1].updated_at)
        if (
          state.ticketRaffles[trid1].updated_at >
          state.ticketRaffles[trid2].updated_at
        ) {
          return -1
        } else {
          return 1
        }
      })

      state.currentTicketRaffleIds = ids
    },
    setTicketRaffleEntries (state, [tres, winners]) {
      // console.log('settings entries', tres, winners)
      for (let tre of tres) {
        tre.updated_at = moment(tre.updated_at)
        tre.created_at = moment(tre.created_at)
      }

      for (let tre of winners) {
        tre.updated_at = moment(tre.updated_at)
        tre.created_at = moment(tre.created_at)
      }

      tres.sort((tre1, tre2) => {
        if (tre1.quantity > tre2.quantity) {
          return -1
        } else if (tre2.quantity > tre1.quantity) {
          return 1
        }

        if (tre1.updated_at > tre2.updated_at) {
          return -1
        } else {
          return 1
        }
      })

      Vue.set(state.ticketRaffleEntries, tres[0].ticket_raffle_id, tres)
      Vue.set(state.ticketRaffleWinners, tres[0].ticket_raffle_id, winners)
    },
    newBets (state, bets) {
      for (let bet of bets) {
        Vue.set(state.bets, bet.id, bet)
      }
      let cbids = bets.map(b => b.id)

      cbids.sort((bid1, bid2) => {
        if (
          moment(state.bets[bid1].created_at) >
          moment(state.bets[bid2].created_at)
        ) {
          return -1
        } else {
          return 1
        }
      })

      state.currentBetIds = cbids
    },
    newBet (state, bet) {
      Vue.set(state.bets, bet.id, bet)

      if (state.currentBetIds.indexOf(bet.id) === -1) {
        state.currentBetIds.unshift(bet.id)
      }

      state.currentBetIds.sort((bid1, bid2) => {
        if (
        moment(state.bets[bid1].created_at) >
        moment(state.bets[bid2].created_at)
      ) {
          return -1
        } else {
          return 1
        }
      })
    },
    newPlacedBet (state, data) {
      let bet = data.bet
      let previousSavedBet = state.bets ? state.bets[bet.id] : undefined

      if (state.currentBetIds.indexOf(bet.id) === -1) {
        state.currentBetIds.unshift(bet.id)

        state.currentBetIds.sort((bid1, bid2) => {
          if (state.bets[bid1].status < state.bets[bid2].status) {
            return -1
          } else if (state.bets[bid1].status > state.bets[bid2].status) {
            return 1
          } else {
            if (
              moment(state.bets[bid1].created_at) >
              moment(state.bets[bid2].created_at)
            ) {
              return -1
            } else {
              return 1
            }
          }
        })
      }

      if (previousSavedBet) {
        previousSavedBet.total = bet.total
        previousSavedBet.bet_options = previousSavedBet.bet_options || []

        let bo = previousSavedBet.bet_options.find(
          b => b.option_number === data.bet_option.option_number
        )
        if (bo) {
          Object.assign(bo, data.bet_option)
        }
      } else {
        data.bet.bet_options = [data.bet_option]
        previousSavedBet = data.bet
        this.commit('newBet', data.bet)
      }

      Vue.set(state.bets, previousSavedBet.id, previousSavedBet)

      data.placed_bet.amount = new BigNumber(data.placed_bet.amount)

      if (!state.placedBets[previousSavedBet.id]) {
        Vue.set(state.placedBets, previousSavedBet.id, [data.placed_bet])
      } else {
        let pbs = state.placedBets[previousSavedBet.id]
        pbs.push(data.placed_bet)

        pbs.sort((pb1, pb2) => {
          if (pb1.amount.gt(pb2.amount)) {
            return -1
          } else if (pb2.amount.gt(pb1.amount)) {
            return 1
          } else {
            return 0
          }
        })

        if (data.placed_bet.user_id === state.currentUser.id) {
          let mbs = state.myBets[previousSavedBet.id] || []
          mbs.push(data.placed_bet)

          mbs.sort((pb1, pb2) => {
            if (pb1.amount.gt(pb2.amount)) {
              return -1
            } else if (pb2.amount.gt(pb1.amount)) {
              return 1
            } else {
              return 0
            }
          })

          Vue.set(state.myBets, previousSavedBet.id, mbs)
        }
        Vue.set(state.placedBets, previousSavedBet.id, pbs)
      }
    },
    usersUpdate (state, users) {
      for (let user of users) {
        Vue.set(state.users, user.id, user)
        Vue.set(state.userIdByTwitchNames, user.twitch_name, user.id)
      }
    },
    balanceLeaderboardUpdate (state, leaders) {
      state.balanceLeaderboard = leaders
    },
    watchTimeLeaderboardUpdate (state, leaders) {
      state.watchTimeLeaderboard = leaders
    },
    currentUser (state, user) {
      if (!user) {
        Vue.set(state, 'noCurrentUser', true)
      }
      Vue.set(state, 'currentUser', user)
    },
    currentBalance (state, balances) {
      if (Array.isArray(balances)) {
        let sb = balances.find(b => b.currency_type === 'sb')
        let gold = balances.find(b => b.currency_type === 'mt')
        Vue.set(state, 'currentBalance', sb)
        Vue.set(state, 'currentGoldBalance', gold)
      } else {
        Vue.set(state, 'currentBalance', balances)
      }
    },
    subBountiesUpdate (state, bountiesx) {
      let minBounties = []
      const minBounite = bountiesx.tier === 3 ? 50000000000000 : bountiesx.tier === 2 ? 20000000000000 : 0
      bountiesx.bounties.forEach(element => {
        if (Number(element.amount) >= minBounite) {
          minBounties.push(element)
        }
      })
      Vue.set(state.subBounties, 'sub_bounties_t' + bountiesx.tier, minBounties)
    },
    roomItemPageUpdate (state, params) {
      if (params.loot_items && params.loot_items.length > 0) {
        state.roomItemPageCurrent = state.roomItemPages.length
        state.roomItemPages.push({loot_items: params.loot_items, cursor: params.cursor})
      }
    },
    roomItemPageReset (state, items, cursor) {
      Vue.set(state.roomItemPages, [])
      // Vue.set(state.roomItemPageCurrent, -1)
      state.roomItemPageCurrent = -1
    },
    gotoRoomPage (state, page) {
      state.roomItemPageCurrent = page
    },
    lootBoxPageUpdate (state, params) {
      if (params.loot_items && params.loot_items.length > 0) {
        state.lootBoxPageCurrent = state.lootBoxPages.length
        state.lootBoxPages.push({loot_items: params.loot_items, cursor: params.cursor})
      }
    },
    lootBoxPageReset (state, items, cursor) {
      Vue.set(state.lootBoxPages, [])
      // Vue.set(state.roomItemPageCurrent, -1)
      state.lootBoxPageCurrent = -1
    },
    lootBoxPage (state, page) {
      state.lootBoxPageCurrent = page
    },
    setUserRates (state, rates) {
      state.userRates = rates
    }
  },
  actions: {
    async fetchCurrentUser (context) {
      if (context.state.currentUser) {
        return context.state.currentUser
      }

      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/users/me`,
          { withCredentials: true }
        )

        context.commit('usersUpdate', [response.data.user])
        context.commit('currentUser', response.data.user)

        context.dispatch('fetchMyTickets')

        const response2 = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/balances/me`,
          { withCredentials: true }
        )

        context.commit('currentBalance', response2.data.balances)
      } catch (e) {
        context.commit('currentUser')
        console.log('FETCH CURRENT ERROR', e)
      }
    },
    async fetchBalances (context) {
      try {
        const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/balances/me`, {withCredentials: true})
        context.commit('currentBalance', response.data.balances)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchUser (context, userId) {
      // userId = userId.toLowerCase()
      if (context.state.users[userId]) {
        return context.state.users[userId]
      }

      if (!userId || userId.toString() === 'undefined') {
        return
      }

      const response = await axios.get(
        `${Vue.config.CURRENCY_SERVICE_BASE_URL}/users/${userId}`
      )

      context.commit('usersUpdate', [response.data.user])

      return response.data.user
    },
    async fetchUserByTwitchName (context, twitchName) {
      // userId = userId.toLowerCase()
      if (context.state.userIdByTwitchNames[twitchName]) {
        return context.state.users[context.state.userIdByTwitchNames[twitchName]]
      }

      if (!twitchName || twitchName.toString() === 'undefined') {
        return
      }

      const response = await axios.get(
        `${Vue.config.CURRENCY_SERVICE_BASE_URL}/users?twitch_name=${twitchName}`
      )

      context.commit('usersUpdate', [response.data.user])

      return response.data.user
    },
    async fetchTicketRaffle (context, ticketRaffleId) {
      try {
        if (context.state.ticketRaffles[ticketRaffleId]) {
          return context.state.ticketRaffles[ticketRaffleId]
        }

        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/ticket_raffles/${ticketRaffleId}`
        )
        context.commit('newTicketRaffle', [response.data.ticket_raffle])
      } catch (e) { }
    },
    async fetchLootShopLootItems (context, channelId = 'default') {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/loot_shop/loot_items`
        )
        context.commit('setLootShopLootItems', response.data.loot_items)
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) { }
    },
    async fetchLootItem (context, itemId) {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/loot_items/${itemId}`
        )
        context.commit('setLootItems', [response.data.loot_item])
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) { }
    },
    async fetchOwnedLootItems (context, channelId = 'default') {
      try {
        if (!context.state.currentUser) {
          return context.state.currentUser
        }

          // /users/{userId}/owned_loot_items
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/users/${context.state.currentUser.id}/owned_loot_items?channel_id=${channelId}`
        )

        // context.commit('setLootItems', response.data.loot_items || [])
        context.commit('setOwnedLootItems', response.data.owned_loot_items)
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) {
        console.log('Error fetching owned loot items', e)
      }
    },
    async fetchCurrentTicketRaffles (context, channelId = 'default') {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/channels/${channelId}/ticket_raffles`
        )
        context.commit('setTicketRaffles', response.data.ticket_raffles)
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) { }
    },
    async fetchMyTickets (context, channelId = 'default') {
      try {
        if (!context.state.currentUser) {
          return context.state.currentUser
        }

        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/channels/${channelId}/ticket_raffles?userId=${context.state.currentUser.id}`
        )
        context.commit('setMyTickets', response.data.ticket_raffles)
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) { }
    },
    async fetchTicketRaffleEntries (context, ticketRaffleId) {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/ticket_raffles/${ticketRaffleId}/entries`
        )
        context.commit('setTicketRaffleEntries', [
          response.data.ticket_raffle_entries,
          response.data.ticket_raffle_winners
        ])
        response.data.ticket_raffle_entries.sort((a, b) => (parseFloat(a.quantity) < parseFloat(b.quantity)) ? 1 : ((parseFloat(b.quantity) < parseFloat(a.quantity)) ? -1 : 0))
        return true
      } catch (e) {
        return []
      }
    },
    async fetchCurrentBets (context, channelId = 'default') {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/channels/${channelId}/bets`
        )
        context.commit('newBets', response.data.bets)
        // for (let bet of response.data.bets.reverse()) {
        //   context.commit('newBet', bet)
        // }
      } catch (e) { }
    },
    async fetchPlacedBets (context, betId) {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/bets/${betId}/placed_bets`
        )
        context.state.bets[betId].participantsCount = Object.keys(_(response.data.placed_bets).groupBy('user_id').value()).length
        context.commit('placedBetsUpdate', response.data)
        return true
      } catch (e) {
        return []
      }
    },
    async fetchBet (context, betId) {
      try {
        if (context.state.bets[betId]) {
          return context.state.bets[betId]
        }

        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/bets/${betId}`
        )
        context.commit('betsUpdate', [response.data.bet])

        return response.data.bet
      } catch (e) {
        return []
      }
    },
    async fetchBalanceLeaderboard (context) {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/leaderboards/default/balance`
        )
        context.commit('balanceLeaderboardUpdate', response.data.leaders)
      } catch (e) {
        console.log('Error Fetching Balance Leaderboard', e)
      }
    },
    async fetchWatchTimeLeaderboard (context, channelId = 'default') {
      try {
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/leaderboards/${channelId}/watch_time`
        )
        context.commit('watchTimeLeaderboardUpdate', response.data.leaders)
      } catch (e) {
        console.log('Error Fetching Watch Time Leaderboard', e)
      }
    },
    async fetchSubBounties (context, bountieProbs) {
      try {
        const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/sub_bounties?channelId=${bountieProbs.channelId}&tier=${bountieProbs.tier}`)
        context.commit('subBountiesUpdate', {tier: bountieProbs.tier, bounties: response.data.sub_bounties})
      } catch (e) {
        console.log('Error Fetching Sub Bounties', e)
      }
    },
    async captureDonation (context, {orderId, message}) {
      try {
        const response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/donations`, {orderId: orderId, message: message}, {withCredentials: true})
        // context.commit('subBountiesUpdate', response.data.sub_bounties)
        return response.data
      } catch (e) {
        console.log('Error Fetching Sub Bounties', e)
        return {error: e}
      }
    },
    async buyTicket (context, dets) {
      if (store.state.currentUser) {
        store.state.callFree = false
        axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/ticket_raffles/${dets.raffleIdx.toString()}`, {
          'amount': dets.amount.toString(),
          'userId': store.state.currentUser.id.toString()
        })
        .then(function (response) {
          context.dispatch('fetchMyTickets')
          store.dispatch('fetchBalances')
          store.state.callFree = true
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    async placeBet (context, dets) {
      if (store.state.currentUser) {
        store.state.callFree = false
        axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/bets/${dets.betIdx.toString()}`, {
          'amount': dets.amount.toString(),
          'option': dets.option.toString(),
          'userId': store.state.currentUser.id.toString()
        }, {withCredentials: true})
        .then(function (response) {
          store.state.callFree = true
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    async saveRoom (context, roomParams) {
      store.state.callFree = false
      return axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/rooms/${store.state.currentUser.id.toString()}`, {
        'items': roomParams.items
      }, {withCredentials: true})
      .then(function (response) {
        store.state.callFree = true
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    async createRoomItem (context, params) {
      store.state.callFree = false
      return axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room-items`, params.formData, {withCredentials: true})
      .then(function (response) {
        store.state.callFree = true
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    async fetchRoomPage (context, cursor) {
      try {
        let qs = ''
        if (cursor) { qs = `?cursor=${cursor}` }
        const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/room_items${qs}`, { withCredentials: true })
        context.commit('roomItemPageUpdate', {cursor: response.data.meta.cursor, loot_items: response.data.loot_items})
      } catch (e) {
        console.log('Error Fetching Room Items', e)
      }
    },
    async roomItemPageReset (context) {
      context.commit('roomItemPageReset')
    },
    async gotoRoomPage (context, page) {
      context.commit('gotoRoomPage', page)
    },
    async fetchLootBoxPage (context, cursor) {
      try {
        let qs = ''
        if (cursor) { qs = `?cursor=${cursor}` }
        const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/loot_boxes${qs}`, { withCredentials: true })
        context.commit('lootBoxPageUpdate', {cursor: response.data.meta.cursor, loot_items: response.data.loot_items})
      } catch (e) {
        console.log('Error Fetching Room Items', e)
      }
    },
    async lootBoxPageReset (context) {
      context.commit('lootBoxPageReset')
    },
    async lootBoxPage (context, page) {
      context.commit('gotoLootBoxPage', page)
    },
    async fetchUserRates (context) {
      try {
        if (!context.state.currentUser) {
          return
        }
        const response = await axios.get(
          `${Vue.config.CURRENCY_SERVICE_BASE_URL}/users/${context.state.currentUser.id}/rate_details`
        )
        context.commit('setUserRates', response.data.rate_details)
      } catch (e) {
        console.log('Error fetching user rates', e)
      }
    }
  }
})

store.connect = function () {
  let client = new Nes.Client(Vue.config.WS_SERVICE_BASE_URL) // ws://localhost:8001/ws') // ue.config.WS_SERVICE_BASE_URL)
  client.connect(function (err) {
    if (err) {
      return
    }

    let newTicketRaffleHandler = function (update, flags) {
      store.commit('newTicketRaffle', update.ticket_raffle)
    }

    client.subscribe('/new_ticket_raffle', newTicketRaffleHandler, function (err) {
      // console.log('subscribed', err)
      if (err) { console.log(err) }
    })

    let newTicketRaffleEntryHandler = function (update, flags) {
      store.commit('newTicketRaffleEntry', update.ticket_raffle_entry)
    }

    client.subscribe(
      '/new_ticket_raffle_entry',
      newTicketRaffleEntryHandler,
      function (err) {
        if (err) { console.log(err) }
        // console.log('subscribed', err)
      }
    )

    let newTicketRaffleWinnerHandler = function (update, flags) {
      // console.log('ticketwinner', update)
      store.commit('newTicketRaffleWinner', update.ticket_raffle_winner)
    }

    client.subscribe(
      '/new_ticket_raffle_winner',
      newTicketRaffleWinnerHandler,
      function (err) {
        // console.log('subscribed', err)
        if (err) { console.log(err) }
      }
    )

    let newBetsHandler = function (update, flags) {
      // console.log('new bet', update, flags)

      if (store.state.placedBets[update.bet.id]) {
        store.dispatch('fetchPlacedBets', update.bet.id)
      }

      store.commit('newBet', update.bet)
    }

    client.subscribe('/new_bets', newBetsHandler, function (err) {
      // console.log('subscribed', err)
      if (err) { console.log(err) }
    })

    let newPlacedBetsHandler = function (update, flags) {
      // console.log('new placed bet', update, flags)
      store.commit('newPlacedBet', update)
    }

    client.subscribe('/new_placed_bets', newPlacedBetsHandler, function (err) {
      // console.log('subscribed', err)
      if (err) { console.log(err) }
    })

    client.request('/h', function (err, payload) {
      if (err) {
        return
      }
      // console.log('wat', payload)
    })

    store.dispatch('fetchCurrentUser')
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js